import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = { whatsapp: "573166919233", banco: "Por confirmar", cuenta: "Por confirmar", llave: "Por confirmar", nit: "Por confirmar", qr: false, qr_version: 0 };
const SettingsCtx = createContext({ settings: DEFAULTS, setSettings: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (e) {
      /* keep defaults */
    }
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  return <SettingsCtx.Provider value={{ settings, setSettings }}>{children}</SettingsCtx.Provider>;
}

export const useSettings = () => useContext(SettingsCtx);
